import { code as statuses } from 'statuses';

class AppAPIVersionInterceptor {
  constructor($q, appEvents, APP_EVENTS) {
    'ngInject';

    this.$q = $q;
    this.appEvents = appEvents;
    this.APP_EVENTS = APP_EVENTS;

    this.responseError = this.responseError.bind(this);
  }
  responseError(response) {
    if (
      response.status === statuses.conflict &&
      response.data.data &&
      response.data.data.api
    ) {
      this.appEvents.emit(this.APP_EVENTS.outdated);
    }

    return this.$q.reject(response);
  }
}

export default AppAPIVersionInterceptor;
